<div class="full-screen">
    <div class="d-flex flex-grow-1" style="max-width: 100%;">
        <div class="zx-settings-nav flex-shrink h-100 d-flex flex-column overflow-hidden"
            [class.zx-settings-nav-dark]="isDarkMode">
            <article class="w-100 h-100 d-flex pt-3 flex-column overflow-auto">
                <article class="w-100 d-flex flex-column gap-2 flex-grow-1">

                    <div class="w-100 d-flex px-3">
                        <app-navigation-to-products class="d-flex flex-grow-1"></app-navigation-to-products>
                        <div *ngIf="isManiger()" class="pb-3 px-1 d-flex align-items-center zx-management-con">
                            <div class="pt-1 d-flex rounded-2 c-pointer opacity-50" mat-ripple
                                [matMenuTriggerFor]="ManigerManu"
                                [matTooltip]="'main-nav.super-management-mode' | translate"
                                [matTooltipPosition]="'below'">
                                <mat-icon class="c-pointer">settings</mat-icon>
                            </div>
                            <mat-menu #ManigerManu="matMenu">
                                <!-- printer -->
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                    mat-menu-item (click)="goToManagementPage('printer')">
                                    <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                        {{ 'su-management.printer-management' | translate }}
                                    </b>
                                    <mat-icon class="mx-1 p-0 zx-pt-small"
                                        [class.zx-text-white]="isDarkMode">print</mat-icon>
                                </button>
                                <!-- orders -->
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                    mat-menu-item (click)="goToManagementPage('orders')">
                                    <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                        {{ 'su-management.orders-management' | translate }}
                                    </b>
                                    <mat-icon class="mx-1 p-0 zx-pt-small"
                                        [class.zx-text-white]="isDarkMode">assignment</mat-icon>
                                </button>
                                <!-- users -->
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                    mat-menu-item (click)="goToManagementPage('users')">
                                    <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                        {{ 'su-management.users-management' | translate }}
                                    </b>
                                    <mat-icon class="mx-1 p-0 zx-pt-small"
                                        [class.zx-text-white]="isDarkMode">supervisor_account</mat-icon>
                                </button>
                                <!-- inventory -->
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                    mat-menu-item (click)="goToManagementPage('inventory')">
                                    <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                        {{ 'su-management.inventory-management' | translate }}
                                    </b>
                                    <mat-icon class="mx-1 p-0 zx-pt-small"
                                        [class.zx-text-white]="isDarkMode">ballot</mat-icon>
                                </button>
                                <!-- branch -->
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                    mat-menu-item (click)="goToManagementPage('branch')">
                                    <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                        {{ 'su-management.branch-management' | translate }}
                                    </b>
                                    <mat-icon class="mx-1 p-0 zx-pt-small"
                                        [class.zx-text-white]="isDarkMode">how_to_reg</mat-icon>
                                </button>
                                <!-- report -->
                                <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL"
                                    mat-menu-item (click)="goToManagementPage('report')">
                                    <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
                                        {{ 'su-management.report-management' | translate }}
                                    </b>
                                    <mat-icon class="mx-1 p-0 zx-pt-small"
                                        [class.zx-text-white]="isDarkMode">equalizer</mat-icon>
                                </button>
                            </mat-menu>
                        </div>
                    </div>

                    <div class="w-100 d-flex flex-column-reverse flex-md-row flex-grow-1">

                        <div class="zx-files-area-outer-outer">
                            <div class="zx-files-area-outer">
                                <div class="zx-files-area" [class.zx-bg-dark]="isDarkMode">
                                    <div class="d-flex flex-column gap-2">
                                        <h6
                                            class="mb-0 zx-text-small fw-bold zx-text-sm-medium zx-px-10 d-none d-ms-inline">
                                            {{'printing-table.my-order' | translate}}
                                        </h6>
                                        <span class="d-md-none"></span>

                                        <!-- file list [express] -->
                                        <div id="filesAreaExpress" class="zx-files-area-inner">

                                            <!-- upload btn [express] -->
                                            <article mat-ripple
                                                class="zx-files-area-item-small c-pointer rounded-3 p-2 m-lg-1 zx-border-gray-v-v-light
                                                shadow-85-light d-flex flex-column justify-content-center align-items-center"
                                                [class.zx-files-area-item-tiny]="files.length > 0"
                                                [class.zx-border-gray-25-pr]="isDarkMode"
                                                [class.zx-page-obj-container-bg-darkmode]="isDarkMode" ng2FileDrop
                                                [uploader]="uploader" (fileOver)="fileOverBase($event)"
                                                (onFileDrop)="onFileDrop($event)"
                                                [ngClass]="{'file-drop-hover': hasBaseDropZoneOver}"
                                                (click)="fileInput.click()">
                                                <!-- uplaod file -->
                                                <img *ngIf="files.length > 0 && !currentlyUploading"
                                                    src="/assets/images/upload-file-next-icon.svg"
                                                    class="upload-file-icon-small-next svg c-pointer">
                                                <div *ngIf="files.length === 0 && !currentlyUploading">
                                                    <img src="/assets/images/upload-file-icon.svg"
                                                        class="upload-file-icon svg c-pointer"
                                                        [@rattleAnimation]="rattle">
                                                </div>
                                                <div *ngIf="!currentlyUploading">
                                                    <h6 class="mb-0 zx-text-small fw-bold zx-text-sm-medium zx-px-10 text-center"
                                                        [@textAnimation]="rattle && files.length > 0">
                                                        {{'printing-table.upload-file' | translate}}
                                                    </h6>
                                                </div>
                                                <input type="file" ng2FileSelect [uploader]="uploader" #fileInput hidden
                                                    multiple />
                                                <!-- // uplaod file -->
                                                <!-- uplaod progress -->
                                                <div *ngIf="currentlyUploading"
                                                    class="d-flex flex-column h-100 w-100 justify-content-center align-items-center">
                                                    <div
                                                        class="w-100 d-flex flex-column flex-grow-1 justify-content-center align-items-center gap-1 gap-lg-2">
                                                        <b class="zx-text-big text-green">
                                                            <span>{{uploadProgress}}</span>
                                                            <span>%</span>
                                                        </b>
                                                        <span class="zx-text-small opacity-75"
                                                            *ngIf="uploadingFiles.length > 1">
                                                            <span>
                                                                {{ 'printing-table.file' | translate }}
                                                            </span>
                                                            <span>1</span>
                                                            <span>
                                                                {{ 'printing-table.out-of' | translate }}
                                                            </span>
                                                            <span>
                                                                {{uploadingFiles.length}}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="w-100 d-flex flex-column justify-content-center align-items-center gap-1 gap-lg-2">
                                                        <mat-progress-bar mode="determinate"
                                                            [value]="uploadProgress"></mat-progress-bar>
                                                        <h6 class="zx-text-medium">
                                                            <span *ngIf="uploadingFiles.length === 1">
                                                                {{ 'printing-table.uploading-file-one' | translate }}
                                                            </span>
                                                            <span *ngIf="uploadingFiles.length > 1">
                                                                {{ 'printing-table.uploading-file-multi' | translate }}
                                                            </span>
                                                        </h6>
                                                    </div>
                                                </div>
                                                <!-- // plaod progress -->
                                            </article>

                                            <!-- files [express] -->
                                            <article *ngFor="let file of files; index as i" #fileExpressElement
                                                class="zx-file-obj">

                                                <!-- proccessing files [express] -->
                                                <div *ngIf="file.images?.length === 0"
                                                    class="zx-files-area-item-small zx-img-obj-container rounded-3 pb-2 zx-border-gray-v-v-light
                                                  shadow-85-light d-flex flex-column justify-content-between align-items-center position-relative"
                                                    [class.zx-border-gray-25-pr]="isDarkMode"
                                                    [class.zx-page-obj-container-bg-darkmode]="isDarkMode">
                                                    <div
                                                        class="position-absolute d-flex px-2 zx-pb-12 rounded-pill bottom-0 w-100">
                                                        <div matRipple [matMenuTriggerFor]="deleteManu"
                                                            class="delete-button delete-button-fix-mobile d-flex justify-content-center align-items-center zx-bg-light c-pointer">
                                                            <mat-icon
                                                                class="text-red mx-0 mt-0 mb-1 p-1 zx-text-medium c-pointer">delete_outline</mat-icon>
                                                        </div>
                                                        <mat-menu #deleteManu="matMenu">
                                                            <button class="d-flex align-items-center gap-1 px-2"
                                                                [class.zx-ltr]="!isRTL" mat-menu-item
                                                                (click)="onDeleteFileOrImage(file, i, null, 0, true, true)">
                                                                <b class="text-red zx-text-small m-0"
                                                                    [class.zx-text-white]="isDarkMode">
                                                                    {{'printing-table.delete-file-for-good'
                                                                    | translate}}
                                                                </b>
                                                                <mat-icon class="text-red mx-1 p-0 zx-pt-small"
                                                                    [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                                                            </button>
                                                        </mat-menu>
                                                    </div>
                                                    <!-- name -->
                                                    <div class="w-100 d-flex justify-content-center align-items-center">
                                                        <span class="opacity-trans"
                                                            [class.opacity-trans-not-rtl]="!isRTL">
                                                            <span class="zx-text-tiny fw-bold">
                                                                {{file.fileName.split('-')[1] | slice:0:16}}
                                                            </span>
                                                            <span class="zx-text-tiny"
                                                                *ngIf="file.fileName.split('-')[1].length > 16">
                                                                ...
                                                            </span>
                                                        </span>
                                                    </div>
                                                    <!-- spinner -->
                                                    <div class="zx-small-icon-size zx-small-plus-icon-size-lg">
                                                        <mat-spinner class="w-100 h-100"></mat-spinner>
                                                    </div>
                                                    <!-- proccessing text -->
                                                    <h6 class="mb-0 zx-text-small text-center opacity-trans zx-z-index-1"
                                                        [class.opacity-trans-not-rtl]="!isRTL"
                                                        [matTooltip]="'printing-table.proccessing.explain' | translate"
                                                        [matTooltipPosition]="'above'" [dir]="tooltipDirection">
                                                        {{ 'printing-table.proccessing' | translate }}
                                                    </h6>
                                                </div>
                                                <!-- // proccessing files [express] -->

                                                <!-- finished files [express] -->
                                                <div class="zx-page-obj-container" *ngIf="file.images.length > 0"
                                                    [class.zx-bg-choosen]="file.fileName === currentFile.fileName && file.images.length > 1"
                                                    [class.zx-page-obj-container-bg]="file.images.length > 1"
                                                    [class.zx-page-obj-container-bg-darkmode]="file.images.length > 1 && isDarkMode">
                                                    <!-- file.images [express] -->
                                                    <article *ngFor="let image of file.images; let j = index"
                                                        (click)="onChooseImage(file, image, j)" class="zx-page-obj"
                                                        [class.zx-page-obj-first]="j === 0 && file.images.length > 1">
                                                        <div *ngIf="file.images.length > 1 && j === 0"
                                                            [class.text-green-imp]="file.fileName === currentFile.fileName"
                                                            [class.zx-text-white-imp]="file.fileName === currentFile.fileName && isDarkMode"
                                                            class="w-100 d-flex justify-content-between px-2 align-items-center">
                                                            <span>
                                                                <span class="zx-text-tiny fw-bold">
                                                                    {{file.fileName.split('-')[1] | slice:0:12}}
                                                                </span>
                                                                <span class="zx-text-tiny"
                                                                    *ngIf="file.fileName.split('-')[1].length > 12">
                                                                    ...
                                                                </span>
                                                            </span>
                                                            <span class="zx-text-tiny opacity-75">
                                                                <span>
                                                                    {{file.images.length}}
                                                                </span>
                                                                <span>
                                                                    {{'printing-table.pages-short' | translate}}
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <!-- file.images - inner rectangle [express] -->
                                                        <article
                                                            [class.zx-border-choosen]="file.fileName === currentFile.fileName && currentImageIndex === j"
                                                            class="zx-img-obj-container-container c-pointer rounded-3 d-flex flex-column zx-border-gray-v-v-light shadow-85-light w-100 h-100 flex-grow-1 "
                                                            [class.zx-height-201]="j === 0"
                                                            [class.zx-border-gray-25-pr]="isDarkMode"
                                                            [class.bg-white]="isDarkMode">
                                                            <span *ngIf="!(file.images.length > 1)"
                                                                [class.zx-img-title-hover]="currentFile.images.length === 1"
                                                                [class.text-green]="file.fileName === currentFile.fileName"
                                                                [class.text-black-imp]="isDarkMode"
                                                                [class.text-green-imp]="file.fileName === currentFile.fileName && isDarkMode">
                                                                <span class="zx-text-tiny fw-bold w-100 text-center">
                                                                    {{file.fileName.split('-')[1] | slice:0:16}}
                                                                </span>
                                                                <span class="zx-text-tiny"
                                                                    *ngIf="file.fileName.split('-')[1].length > 16">
                                                                    ...
                                                                </span>
                                                            </span>
                                                            <div class="zx-img-obj-container">
                                                                <img [src]="expressServerAdress + '/uploads/' + getUserName() + '/' + image.thumbnailPath.split('/').pop()"
                                                                    class="zx-img-obj" alt="File Image">
                                                                <!-- page of page (/) [express] -->
                                                                <div *ngIf="file.images.length > 1"
                                                                    class="position-absolute w-100 px-2 d-flex top-0 pt-md-2">
                                                                    <span
                                                                        class="zx-text-tiny p-1 zx-bg-light zx-text-gray-dark"
                                                                        [class.fw-bold]="file.fileName === currentFile.fileName && image.imagePath === currentImage.imagePath"
                                                                        [class.text-green-imp]="file.fileName === currentFile.fileName && image.imagePath === currentImage.imagePath">
                                                                        <div class="d-flex align-items-center"
                                                                            [class.flex-row-reverse]="isRTL">
                                                                            <span>
                                                                                {{j + 1}}
                                                                            </span>
                                                                            <span>/</span>
                                                                            <span>
                                                                                {{file.images.length}}
                                                                            </span>
                                                                        </div>
                                                                    </span>
                                                                </div>
                                                                <!-- delete [express] -->
                                                                <div class="position-absolute d-none d-md-flex px-2 zx-pb-12 rounded-pill bottom-0 zx-z-index-1"
                                                                    [class.zx-pb-35]="image && !file?.printSettings?.paperType">
                                                                    <div matRipple [matMenuTriggerFor]="deleteManu"
                                                                        class="delete-button d-flex justify-content-center align-items-center zx-bg-light">
                                                                        <mat-icon
                                                                            class="text-red mx-0 mt-0 mb-1 p-1 zx-text-medium">delete_outline</mat-icon>
                                                                    </div>
                                                                    <mat-menu #deleteManu="matMenu">
                                                                        <button *ngIf="currentFile.images.length !== 1"
                                                                            class="d-flex align-items-center gap-1 px-2"
                                                                            [class.zx-ltr]="!isRTL" mat-menu-item
                                                                            (click)="onDeleteFileOrImage(file, i, image, j)">
                                                                            <b class="text-red zx-text-small m-0"
                                                                                [class.zx-text-white]="isDarkMode">
                                                                                {{'printing-table.delete-page-for-good'
                                                                                | translate}}
                                                                            </b>
                                                                            <mat-icon
                                                                                class="text-red mx-1 p-0 zx-pt-small"
                                                                                [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                                                                        </button>
                                                                        <button
                                                                            class="d-flex align-items-center gap-1 px-2"
                                                                            [class.zx-ltr]="!isRTL" mat-menu-item
                                                                            (click)="onDeleteFileOrImage(file, i, image, j, true)">
                                                                            <b class="text-red zx-text-small m-0"
                                                                                [class.zx-text-white]="isDarkMode">
                                                                                {{'printing-table.delete-file-for-good'
                                                                                | translate}}
                                                                            </b>
                                                                            <mat-icon
                                                                                class="text-red mx-1 p-0 zx-pt-small"
                                                                                [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                                                                        </button>
                                                                    </mat-menu>
                                                                </div>
                                                                <!-- paper is not set [express] -->
                                                                <div *ngIf="!file?.printSettings?.paperType"
                                                                    class="zx-image-with-no-paper">
                                                                    <img src="/assets/images/exclamation-icon-white.svg"
                                                                        class="zx-small-tiny-icon-size svg c-pointer">
                                                                    <span class="zx-text-tiny text-white">
                                                                        {{'printing-table.image-no-type' | translate}}
                                                                    </span>
                                                                </div>
                                                                <!-- paper is set [express] -->
                                                                <div class="zx-image-with-paper"
                                                                    *ngIf="!(!file?.printSettings?.paperType)">
                                                                    <!-- paper [express] -->
                                                                    <div
                                                                        class="d-flex align-items-center gap-1 px-2 zx-bg-light zx-w-fit-content">
                                                                        <img src="/assets/images/paper-roll-icon.svg"
                                                                            class="zx-small-tiny-icon-size svg c-pointer">
                                                                        <span class="zx-text-tiny zx-text-gray-dark">
                                                                            {{ 'product-type.name-short.' + productName
                                                                            + '-' +
                                                                            file.printSettings.paperType | translate }}
                                                                        </span>
                                                                    </div>
                                                                    <!-- copies and price [express] -->
                                                                    <div
                                                                        class="d-flex align-items-center gap-1 px-2 zx-bg-light zx-w-fit-content">
                                                                        <span class="zx-text-tiny zx-text-gray-dark">
                                                                            <span
                                                                                *ngIf="file.printSettings && file.printSettings.numOfCopies > 1">
                                                                                <span
                                                                                    *ngIf="getImagePrice$(file.printSettings) | async as imagePrice">
                                                                                    {{
                                                                                    roundDownTowDecimal(imagePrice)
                                                                                    }}
                                                                                </span>
                                                                                <span>×</span>
                                                                                <span>
                                                                                    {{
                                                                                    file.printSettings.numOfCopies
                                                                                    }}
                                                                                </span>
                                                                                <span>=</span>
                                                                            </span>
                                                                            <span
                                                                                *ngIf="getImagePrice$(file.printSettings) | async as imagePrice">
                                                                                {{
                                                                                roundDownTowDecimal(
                                                                                (file.printSettings.numOfCopies || 1)
                                                                                *
                                                                                imagePrice)
                                                                                }}
                                                                            </span>
                                                                            <span class="zx-text-tiny-tiny">
                                                                                {{ 'printing-table.nis' | translate
                                                                                }}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </article>
                                                        <!-- // file.images - inner rectangle [express] -->
                                                    </article>
                                                    <!-- // file.images [express] -->
                                                </div>
                                                <!-- // finished files [express] -->

                                            </article>
                                            <!-- // files [express] -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ----------------- printing properties ----------------- -->
                        <div *ngIf="isLoading"
                            class="zx-settings-area mh-100 position-relative justify-content-center align-items-center">
                            <mat-spinner class="zx-small-plus-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
                        </div>
                        <div *ngIf="!isLoading" class="zx-settings-area mh-100 position-relative">
                            <div id="zx-settings-area-inner" class="zx-settings-area-inner w-100 h-100 mh-100 position-absolute
                            d-flex flex-column gap-3" [class.overflow-auto]="!(!currentProductType && currentImage)"
                                [class.overflow-hidden]="!currentProductType && currentImage"
                                [class.zx-settings-area-inner-rtl]="!isRTL">
                                <!-- [printing properties] title: -->
                                <h6
                                    class="d-none d-md-flex mb-0 zx-text-small zx-pt-md-17 fw-bold zx-text-sm-medium zx-px-10">
                                    {{'printing-table.printing-settings' | translate}}
                                </h6>
                                <!-- [printing properties] file name: -->
                                <!-- desktop -->
                                <article class="w-100 d-none d-md-flex justify-content-between align-items-center">
                                    <span>
                                        {{'printing-table.file' | translate}}
                                    </span>
                                    <div class="d-flex flex-row align-items-center gap-2" *ngIf="isChosen" [matTooltip]="((currentFile.fileName.split('-')[1].length > 30 && currentFile.images.length === 1) ||
                                    (currentFile.fileName.split('-')[1].length > 22 && currentFile.images.length !== 1))
                                    ? currentFile.fileName.split('-')[1] : null">
                                        <span *ngIf="!(currentFile.images.length > 1)" class="fw-bold zx-text-pink"
                                            [class.zx-text-white]="isDarkMode">
                                            <span>
                                                {{currentFile.fileName.split('-')[1] | slice:0:30}}
                                            </span>
                                            <span class="zx-text-tiny"
                                                *ngIf="currentFile.fileName.split('-')[1].length > 30">
                                                ...
                                            </span>
                                        </span>
                                        <span *ngIf="currentFile.images.length > 1" class="fw-bold zx-text-pink"
                                            [class.zx-text-white]="isDarkMode">
                                            <span>
                                                {{currentFile.fileName.split('-')[1] | slice:0:22}}
                                            </span>
                                            <span class="zx-text-tiny"
                                                *ngIf="currentFile.fileName.split('-')[1].length > 22">
                                                ...
                                            </span>
                                        </span>
                                        <div class="d-flex align-items-center gap-1 px-2 rounded-pill zx-border-pink-light-25-pr"
                                            *ngIf="currentFile.images.length > 1">
                                            <span [class.zx-text-white]="isDarkMode" class="zx-text-tiny zx-text-pink">
                                                {{'printing-table.pages-short' | translate}}
                                            </span>
                                            <div class="d-flex align-items-center" [class.flex-row-reverse]="isRTL">
                                                <span [class.zx-text-white]="isDarkMode"
                                                    class="zx-text-tiny zx-text-pink">
                                                    {{currentImageIndex + 1}}
                                                </span>
                                                <span [class.zx-text-white]="isDarkMode"
                                                    class="zx-text-tiny zx-text-pink">
                                                    /
                                                </span>
                                                <span [class.zx-text-white]="isDarkMode"
                                                    class="zx-text-tiny zx-text-pink">
                                                    {{currentFile.images.length}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                                <!-- mobile -->
                                <article *ngIf="currentImage"
                                    class="w-100 d-flex p-2 d-flex d-md-none align-items-center bg-white rounded-4 gap-2"
                                    [class.zx-bg-dark]="isDarkMode">
                                    <div class="zx-medium-plus-icon-size position-relative" (click)="showPreview()">
                                        <img class="w-100 h-100 object-fit-contain rounded-3"
                                            [src]="expressServerAdress + '/uploads/' + getUserName() + '/' + currentImage.thumbnailPath.split('/').pop()"
                                            alt="Current File Image">
                                        <div matRipple
                                            class="w-100 h-100 d-flex justify-content-center align-items-center rounded-3 position-absolute zx-bg-dark-light top-0">
                                            <img class="zx-medium-icon-size svg opacity-75 p-1"
                                                src="assets/images/eye-icon.svg" alt="Full Screen Preview">
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center gap-1 flex-grow-1 h-100">
                                        <div class="d-flex flex-row align-items-center gap-2" *ngIf="isChosen">
                                            <span *ngIf="!(currentFile.images.length > 1)" class="fw-bold zx-text-pink"
                                                [class.zx-text-white]="isDarkMode">
                                                <span>
                                                    {{currentFile.fileName.split('-')[1] | slice:0:22}}
                                                </span>
                                                <span class="zx-text-tiny"
                                                    *ngIf="currentFile.fileName.split('-')[1].length > 22">
                                                    ...
                                                </span>
                                            </span>
                                            <span [class.zx-text-white]="isDarkMode"
                                                *ngIf="currentFile.images.length > 1" class="fw-bold zx-text-pink">
                                                <span>
                                                    {{currentFile.fileName.split('-')[1] | slice:0:10}}
                                                </span>
                                                <span class="zx-text-tiny"
                                                    *ngIf="currentFile.fileName.split('-')[1].length > 10">
                                                    ...
                                                </span>
                                            </span>
                                            <div class="d-flex align-items-center gap-1 px-2 rounded-pill zx-border-pink-light-25-pr"
                                                *ngIf="currentFile.images.length > 1">
                                                <span [class.zx-text-white]="isDarkMode"
                                                    class="zx-text-tiny zx-text-pink">
                                                    {{'printing-table.pages-short' | translate}}
                                                </span>
                                                <div class="d-flex align-items-center" [class.flex-row-reverse]="isRTL">
                                                    <span [class.zx-text-white]="isDarkMode"
                                                        class="zx-text-tiny zx-text-pink">
                                                        {{currentImageIndex + 1}}
                                                    </span>
                                                    <span [class.zx-text-white]="isDarkMode"
                                                        class="zx-text-tiny zx-text-pink">/</span>
                                                    <span [class.zx-text-white]="isDarkMode"
                                                        class="zx-text-tiny zx-text-pink">
                                                        {{currentFile.images.length}}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex" (click)="showPreview()">
                                            <mat-icon style="max-width: 16px;" class="p-0 m-0"
                                                *ngIf="isRTL">keyboard_arrow_right</mat-icon>
                                            <mat-icon style="max-width: 16px;" class="p-0 m-0 zx-rtl"
                                                *ngIf="!isRTL">keyboard_arrow_left</mat-icon>
                                            <span class="zx-text-small">
                                                {{'printing-table.preview' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center h-100">
                                        <img [matMenuTriggerFor]="mobileImageManu"
                                            class="zx-small-plus-icon-size p-1 svg"
                                            src="assets/images/three-dots-icon.svg" alt="Image Options">
                                        <mat-menu #mobileImageManu="matMenu">
                                            <button *ngIf="currentProductType"
                                                class="d-flex align-items-center gap-1 px-2" mat-menu-item
                                                [class.zx-ltr]="!isRTL">
                                                <b class="zx-text-small m-0">
                                                    {{'printing-table.preview' | translate}}
                                                </b>
                                                <mat-icon class="mx-1 p-0 zx-pt-small">fullscreen</mat-icon>
                                            </button>
                                            <button *ngIf="currentFile.images.length !== 1"
                                                class="d-flex align-items-center gap-1 px-2" mat-menu-item
                                                [class.zx-ltr]="!isRTL"
                                                (click)="onDeleteFileOrImage(currentFile, currentFileIndex, currentImage, currentImageIndex)">
                                                <b class="text-red zx-text-small m-0"
                                                    [class.zx-text-white]="isDarkMode">
                                                    {{'printing-table.delete-page-for-good' | translate}}
                                                </b>
                                                <mat-icon class="text-red mx-1 p-0 zx-pt-small"
                                                    [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                                            </button>
                                            <button class="d-flex align-items-center gap-1 px-2" mat-menu-item
                                                [class.zx-ltr]="!isRTL"
                                                (click)="onDeleteFileOrImage(currentFile, currentFileIndex, currentImage, currentImageIndex, true)">
                                                <b class="text-red zx-text-small m-0"
                                                    [class.zx-text-white]="isDarkMode">
                                                    {{'printing-table.delete-file-for-good' | translate}}
                                                </b>
                                                <mat-icon class="text-red mx-1 p-0 zx-pt-small"
                                                    [class.zx-text-white]="isDarkMode">delete_outline</mat-icon>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </article>
                                <div class="w-100 d-flex flex-column gap-3">
                                    <span [class.zx-text-white]="isDarkMode"
                                        class="w-100 zx-text-small text-center zx-text-pink"
                                        *ngIf="currentFile?.images.length > 1">
                                        {{'printing-table.settings-are-for-file' | translate}}
                                    </span>
                                    <hr class="m-0 d-none d-md-flex">
                                </div>
                                <!-- [printing properties] product: -->
                                <article *ngIf="!isLoading"
                                    class="w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'choose-product.product' | translate }}
                                    </span>
                                    <span>{{ "choose-product.naming." + productName | translate }}</span>
                                </article>

                                <!-- [printing properties] type: -->
                                <article *ngIf="!isLoading"
                                    class="w-100 d-flex justify-content-between align-items-center"
                                    [class.flex-column]="productTypes.length > 2"
                                    [class.zx-min-h-50]="productTypes.length <= 2">
                                    <div *ngIf="currentImage" class="d-flex align-items-center gap-2 gap-md-3"
                                        [class.zx-min-h-50]="productTypes.length > 2">
                                        <span [class.zx-text-white]="isDarkMode">
                                            {{'printing-table.type' | translate}}
                                        </span>
                                        <!-- <img #tooltipPaperTrigger src="/assets/images/i-explain-icon.svg"
                                         class="d-none d-lg-flex i-explain-icon svg c-pointer"
                                         (mouseenter)="showPaperTooltip(tooltipPaperTrigger)"
                                         (mouseleave)="hidePaperTooltip()">
                                     <img #tooltipPaperTrigger src="/assets/images/i-explain-icon.svg"
                                         class="d-flex d-lg-none i-explain-icon svg c-pointer"
                                         (click)="openExplainPropertyDialog('paper')"> -->
                                    </div>
                                    <!-- <div *ngIf="!currentImage" class="d-flex align-items-center gap-2 gap-md-3"
                                     [class.zx-min-h-50]="productTypes.length > 2 && !currentProductType">
                                     <span>
                                         {{'printing-table.paper' | translate}}
                                     </span>
                                     <img #tooltipPaperTrigger src="/assets/images/i-explain-icon.svg"
                                         class="d-none d-lg-flex i-explain-icon svg c-pointer"
                                         (mouseenter)="showPaperTooltip(tooltipPaperTrigger)"
                                         (mouseleave)="hidePaperTooltip()">
                                     <img #tooltipPaperTrigger src="/assets/images/i-explain-icon.svg"
                                         class="d-flex d-lg-none i-explain-icon svg c-pointer"
                                         (click)="openExplainPropertyDialog('paper')">
                                 </div> -->

                                    <!-- [printing properties] type -->
                                    <div class="d-flex position-relative"
                                        [class.justify-content-center]="productTypes.length > 2"
                                        [class.justify-content-end]="productTypes.length <= 2"
                                        [@paperAnimation]="noPaper" style="min-width: 88px;">
                                        <mat-button-toggle-group *ngIf="!isLoading"
                                            [class.zx-min-h-50]="productTypes.length > 2" name="product type"
                                            aria-label="Product Type" [(ngModel)]="currentProductType"
                                            (ngModelChange)="onFileSettingsChange()">
                                            <mat-button-toggle [disabled]="!currentImage"
                                                class="zx-rtl zx-animate-paper-normal position-relative"
                                                *ngFor="let type of productTypes; let paperIndex = index"
                                                [value]="type.name" [class.zx-text-white]="isDarkMode"
                                                [class.zx-paper-red]="!currentProductType && currentImage"
                                                [class.zx-paper-red-end]="!currentProductType && currentImage && paperIndex === productTypes.length - 1 && isRTL"
                                                [class.zx-paper-red-end-not-rtl]="!currentProductType && currentImage && paperIndex === productTypes.length - 1 && !isRTL"
                                                [class.zx-paper-red-single-paper]="!currentProductType && currentImage && productTypes.length === 1"
                                                [class.zx-paper-red-middle-paper]="!currentProductType && currentImage && (productTypes.length > 1 && paperIndex !== 0 && paperIndex !== productTypes.length - 1)"
                                                [class.zx-paper-red-middle-paper-not-rtl]="(!currentProductType && currentImage && (productTypes.length > 1 && paperIndex !== 0 && paperIndex !== productTypes.length - 1)) && !isRTL"
                                                [class.choose-paper-not-selected-darkmode]="!currentProductType && currentImage && isDarkMode"
                                                [class.zx-animate-paper-strong]="!currentProductType && isAnimatePaperStrong"
                                                (click)="stopAnimateNoPaper()">
                                                <span>{{ 'product-type.name-short.' + productName + '-' + type.name |
                                                    translate }}</span>
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                        <div *ngIf="currentFile"
                                            [class.d-none]="currentProductType || !isNoPaperAnimating"
                                            [class.d-flex]="!currentProductType && isNoPaperAnimating"
                                            class="zx-no-paper-text-animation"
                                            [class.justify-content-center]="productTypes.length > 1 && !currentProductType"
                                            [class.justify-content-end]="productTypes.length < 2 || currentProductType">
                                            <b class="zx-text-small zx-text-pink no-wrap"
                                                [class.zx-text-white]="isDarkMode">
                                                <span *ngIf="currentFile.images && currentFile.images.length === 1">
                                                    <span>
                                                        {{ 'printing-table.plz-choose-paper' | translate }}
                                                    </span>
                                                    <span>
                                                        <span>
                                                            {{currentFile.fileName.split('-')[1] | slice:0:8}}
                                                        </span>
                                                        <span *ngIf="currentFile.fileName.split('-')[1].length > 8">
                                                            ..
                                                        </span>
                                                    </span>
                                                </span>
                                            </b>
                                        </div>
                                    </div>
                                </article>

                                <div class="animated-height"
                                    [class.zx-100-vh-animation]="currentFile && !currentProductType"></div>

                                <!-- [printing properties] color: -->
                                <article class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'printing-table.color' | translate }}
                                    </span>
                                    <mat-button-toggle-group name="bw" aria-label="bw" [(ngModel)]="bwValue"
                                        [disabled]="!product" (ngModelChange)="onFileSettingsChange()">
                                        <mat-button-toggle [value]="false">
                                            {{ 'printing-table.color-color' | translate }}
                                        </mat-button-toggle>
                                        <mat-button-toggle [value]="true">
                                            {{ 'printing-table.color-bandw' | translate }}
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </article>
                                <!-- [printing properties] scale : -->
                                <article *ngIf="!is3D"
                                    class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'printing-table.size' | translate }}
                                    </span>
                                    <div *ngIf="currentImage" class="d-flex align-items-center gap-1">
                                        <button mat-icon-button (click)="scaleImage('remove')"
                                            [disabled]="!product || scaleValue <= 0.1">
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                        <div class="input-with-scale">
                                            <input class="zx-copies-input zx-scale-input"
                                                [disabled]="!currentProductType"
                                                [class.zx-text-white-bg-transparent]="isDarkMode"
                                                [(ngModel)]="scaleValue" (ngModelChange)="onFileSettingsChange()"
                                                matInput type="number" min="1" [max]="maxScale" step="0.1">
                                        </div>
                                        <button mat-icon-button (click)="scaleImage('add')"
                                            [disabled]="!product || scaleValue >= maxScale">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="!currentImage" class="d-flex align-items-center gap-1">
                                        <button mat-icon-button [disabled]="true">
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                        <input class="zx-copies-input" value=""
                                            [class.zx-text-white-bg-transparent]="isDarkMode" matInput type="number"
                                            [disabled]="true">
                                        <button mat-icon-button [disabled]="true">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </div>
                                </article>
                                <!-- [printing properties] rotate: -->
                                <article *ngIf="is3D"
                                    class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'printing-table.rotate' | translate }}
                                    </span>
                                    <div *ngIf="currentImage" class="d-flex align-items-center gap-1">
                                        <button mat-icon-button (click)="rotateImage('left')" [disabled]="!product">
                                            <mat-icon>rotate_left</mat-icon>
                                        </button>
                                        <div class="input-with-degree">
                                            <input class="zx-copies-input" [disabled]="!currentProductType"
                                                [class.zx-text-white-bg-transparent]="isDarkMode" [(ngModel)]="rotation"
                                                (ngModelChange)="onFileSettingsChange()" matInput type="number" min="0"
                                                max="270" step="90">
                                        </div>
                                        <button mat-icon-button (click)="rotateImage('right')" [disabled]="!product">
                                            <mat-icon>rotate_right</mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="!currentImage" class="d-flex align-items-center gap-1">
                                        <button mat-icon-button [disabled]="true">
                                            <mat-icon>rotate_left</mat-icon>
                                        </button>
                                        <input class="zx-copies-input" value=""
                                            [class.zx-text-white-bg-transparent]="isDarkMode" matInput type="number"
                                            [disabled]="true">
                                        <button mat-icon-button [disabled]="true">
                                            <mat-icon>rotate_right</mat-icon>
                                        </button>
                                    </div>
                                </article>
                                <!-- [printing properties] borders: -->
                                <article *ngIf="printingService && printingService === 'plotter'"
                                    class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center gap-2 gap-md-3">
                                        <span>
                                            {{ 'printing-table.borders' | translate }}
                                        </span>
                                        <img aria-label="Add Borders To Image Explained"
                                            src="/assets/images/i-explain-icon.svg"
                                            class="d-flex d-lg-none i-explain-icon svg c-pointer"
                                            (click)="openExplainPropertyDialog('border')">
                                        <img aria-label="Add Borders To Image Explained"
                                            src="/assets/images/i-explain-icon.svg"
                                            class="d-none d-lg-flex i-explain-icon svg c-pointer"
                                            [matTooltip]="'printing-table.explain-border' | translate"
                                            [matTooltipPosition]="'below'" [dir]="tooltipDirection">
                                    </div>
                                    <mat-slide-toggle [(ngModel)]="cmFromTopValue"
                                        [disabled]="!currentImage || !currentProductType"
                                        (ngModelChange)="onFileSettingsChange()"></mat-slide-toggle>
                                </article>
                                <!-- [printing properties] center: -->
                                <article *ngIf="printingService && printingService === 'plotter'"
                                    class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center gap-2 gap-md-3">
                                        <span>
                                            {{ 'printing-table.center' | translate }}
                                        </span>
                                        <img aria-label="Center Image Explained" src="/assets/images/i-explain-icon.svg"
                                            class="d-flex d-lg-none i-explain-icon svg c-pointer"
                                            (click)="openExplainPropertyDialog('center')">
                                        <img aria-label="Center Image Explained" src="/assets/images/i-explain-icon.svg"
                                            class="d-none d-lg-flex i-explain-icon svg c-pointer"
                                            [matTooltip]="'printing-table.explain-center' | translate"
                                            [matTooltipPosition]="'below'" [dir]="tooltipDirection">
                                    </div>
                                    <mat-slide-toggle [(ngModel)]="centerValue"
                                        [disabled]="!currentImage || !currentProductType"
                                        (ngModelChange)="onFileSettingsChange()"></mat-slide-toggle>
                                </article>
                                <!-- [printing properties] copies: -->
                                <article class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'printing-table.copies' | translate }}
                                    </span>
                                    <div *ngIf="currentImage" class="d-flex align-items-center gap-1">
                                        <button mat-icon-button (click)="changeNumberOfCopies('remove')"
                                            [disabled]="!product || numOfCopies <= 1">
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                        <input class="zx-copies-input" [disabled]="!currentProductType"
                                            [class.zx-text-white-bg-transparent]="isDarkMode" [(ngModel)]="numOfCopies"
                                            (ngModelChange)="onFileSettingsChange()" matInput type="number" min="1">
                                        <button mat-icon-button (click)="changeNumberOfCopies('add')"
                                            [disabled]="!product">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </div>
                                    <div *ngIf="!currentImage" class="d-flex align-items-center gap-1">
                                        <button mat-icon-button [disabled]="true">
                                            <mat-icon>remove</mat-icon>
                                        </button>
                                        <input class="zx-copies-input" value=""
                                            [class.zx-text-white-bg-transparent]="isDarkMode" matInput type="number"
                                            [disabled]="true">
                                        <button mat-icon-button [disabled]="true">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </div>
                                </article>
                                <!-- [printing properties] dimensions: -->
                                <article class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'printing-table.dimensions' | translate }}
                                    </span>
                                    <div *ngIf="currentImage && is3D"
                                        class="d-flex flex-column align-items-center px-2 zx-border-parenthesis">
                                        <span class=" zx-text-tiny-tiny">
                                            <span>
                                                {{ 'printing-table.original-dims' | translate }}
                                            </span>
                                            <span>:</span>
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            <span>
                                                {{ getOriginalWidth() }}
                                            </span>
                                            <span>
                                                ×
                                            </span>
                                            <span>
                                                {{ getOriginalHeight() }}
                                            </span>
                                            <span>
                                                {{ 'printing-table.dimensions-cm' | translate }}
                                            </span>
                                        </span>
                                    </div>
                                    <div *ngIf="currentImage" class="d-flex align-items-center gap-2">
                                        <div class="d-flex align-items-center gap-2">
                                            <div class="d-flex align-items-center gap-1">
                                                <span *ngIf="is3D">
                                                    {{ currentProductTypeObject?.width ?
                                                    currentProductTypeObject.width / 10000 : 0 }}
                                                </span>
                                                <span *ngIf="!is3D">
                                                    {{ (currentImageWidth ? currentImageWidth : 0).toFixed(2)
                                                    }}
                                                </span>
                                                <span>
                                                    ×
                                                </span>
                                                <span *ngIf="is3D">
                                                    {{ currentProductTypeObject?.height ?
                                                    currentProductTypeObject.height / 10000 : 0 }}
                                                </span>
                                                <span *ngIf="!is3D">
                                                    {{ (currentImageHeight ? currentImageHeight : 0).toFixed(2)
                                                    }}
                                                </span>
                                                <span>
                                                    {{ 'printing-table.dimensions-cm' | translate }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                                <!-- [printing properties] price per file: -->
                                <article class="zx-min-h-50 w-100 d-flex justify-content-between align-items-center">
                                    <span>
                                        {{ 'printing-table.price-per-file' | translate }}
                                    </span>
                                    <div class="d-flex align-items-center gap-1" [class.opacity-50]="!currentImage">
                                        <span>
                                            <span
                                                *ngIf="currentPrintSettings && currentFile?.images && currentFile.images.length > 0">
                                                <span *ngIf="currentFile.images.length > 1 || numOfCopies > 1">
                                                    <span *ngIf="currentFile.images.length > 1">
                                                        <span>
                                                            {{currentFile.images.length}}
                                                        </span>
                                                        <span class="zx-text-tiny-tiny">
                                                            {{ 'printing-table.pages-short' | translate
                                                            }}
                                                        </span>
                                                        <span>×</span>
                                                    </span>
                                                    <span *ngIf="numOfCopies > 1">
                                                        <span>
                                                            {{numOfCopies}}
                                                        </span>
                                                        <span class="zx-text-tiny-tiny">
                                                            {{ 'printing-table.copies-short' | translate
                                                            }}
                                                        </span>
                                                        <span>×</span>
                                                    </span>
                                                    <span
                                                        *ngIf="currentPrintSettings && currentFile.images.length > 0 && getImagePrice$(currentPrintSettings) | async as imagePrice">
                                                        {{ roundDownTowDecimal(
                                                        imagePrice) }}
                                                    </span>
                                                    <span class="zx-text-tiny-tiny">
                                                        {{ 'printing-table.nis' | translate
                                                        }}
                                                    </span>
                                                    <span>=</span>
                                                </span>
                                                <span
                                                    *ngIf="!currentFile?.images || !(currentFile?.images.length > 0)  || !product">
                                                    -
                                                </span>
                                            </span>
                                            <span
                                                *ngIf="currentPrintSettings && currentFile?.images.length > 0 && getImagePrice$(currentPrintSettings) | async as imagePrice">
                                                {{ roundDownTowDecimal(currentFile.images.length *
                                                numOfCopies *
                                                imagePrice) }}
                                            </span>
                                            <span class="zx-text-small">
                                                {{ 'printing-table.nis' | translate
                                                }}
                                            </span>
                                        </span>
                                    </div>
                                </article>

                            </div>
                        </div>
                    </div>

                </article>
            </article>
            <!-- total price [DESKTOP] -->
            <div class="w-100 shadow-85-top-strong px-3 pt-2 zx-z-index-1 bg-white d-none d-md-flex justify-content-between align-items-center"
                [class.zx-bg-dark]="isDarkMode">
                <span class="text-green d-flex align-items-center gap-1">

                    <span class="zx-text-tiny d-flex align-items-center gap-1"
                        [class.flex-column]="proccessingFiles.length > 0 || (user?.discount > 0 && totalOrderPrice !== totalOrderPriceBeforeDiscount)"
                        [class.align-items-start]="proccessingFiles.length > 0 || (user?.discount > 0 && totalOrderPrice !== totalOrderPriceBeforeDiscount)"
                        [class.align-items-center]="proccessingFiles.length === 0">
                        <!-- title -->
                        <b class="zx-text-small">
                            {{ 'printing-table.total-price' | translate }}
                        </b>
                        <span *ngIf="!isLoading && files.length > 0" class="d-flex align-items-center gap-1">
                            <!-- files -->
                            <span *ngIf="files.length - proccessingFiles.length > 0">
                                <span *ngIf="proccessingFiles.length === 0">(</span>
                                <span *ngIf="files.length - proccessingFiles.length > 1">
                                    <b>
                                        {{ files.length - proccessingFiles.length }}
                                    </b>
                                    <b class="zx-text-tiny-tiny">
                                        {{ 'printing-table.files' | translate }}
                                    </b>
                                </span>
                                <b class="zx-text-tiny-tiny" *ngIf="files.length - proccessingFiles.length === 1">
                                    {{ 'printing-table.one-file' | translate }}
                                </b>
                                <span *ngIf="proccessingFiles.length === 0">)</span>
                            </span>
                            <!-- , -->
                            <span class="d-none d-lg-inline"
                                *ngIf="files.length - proccessingFiles.length > 0 && proccessingFiles.length > 0">,</span>
                            <!-- proccessing files -->
                            <span class="opacity-trans" *ngIf="proccessingFiles.length > 0">
                                <b *ngIf="proccessingFiles.length > 1">
                                    {{ proccessingFiles.length }}
                                </b>
                                <b *ngIf="proccessingFiles.length > 1" class="zx-text-tiny-tiny">
                                    {{ 'printing-table.files' | translate }}
                                </b>
                                <b *ngIf="proccessingFiles.length === 1" class="zx-text-tiny-tiny">
                                    {{ 'printing-table.one-file' | translate }}
                                </b>
                                <b class="zx-text-tiny-tiny">
                                    {{ 'printing-table.still-proccessing' | translate }}
                                </b>
                            </span>
                        </span>
                    </span>
                </span>

                <!-- pricing line DESKTOP -->
                <span class="text-green" [class.text-start]="isRTL" [class.text-end]="!isRTL" style="max-width: 380px;">
                    <span *ngIf="calcTotalOrderPrice() > 0">
                        <!-- real price -->
                        <span>
                            <b>
                                {{ calcTotalOrderPrice() }}
                            </b>
                            <b class="zx-text-tiny">
                                {{ 'printing-table.nis' | translate }}
                            </b>
                        </span>
                    </span>
                    <!-- empty -->
                    <span class="zx-text-small" *ngIf="calcTotalOrderPrice() === 0">
                        <span>-</span>
                        <span>
                            {{ 'printing-table.nis' | translate }}
                        </span>
                    </span>
                </span>
            </div>
            <!-- main action btn -->
            <div class="w-100 p-2 zx-z-index-1 bg-white" [class.zx-bg-dark]="isDarkMode">
                <!-- next image [btn main action btn] -->
                <button *ngIf="isLoadingPreview || isLoading" disabled color="primary" type="button" mat-raised-button
                    class="text-white rounded-pill w-100 zx-small-btn" [class.opacity-50]="isDarkMode">
                    <div class="d-flex justify-content-center align-items-center w-100">
                        <span>
                            <mat-spinner diameter="17"></mat-spinner>
                        </span>
                    </div>
                </button>
                <!-- uplaod file [btn main action btn] -->
                <button *ngIf="!(files.length !== 0 && files.length !== proccessingFiles.length) && !isLoading"
                    [disabled]="isLoading" color="primary" type="button" mat-raised-button
                    class="text-white rounded-pill w-100 zx-small-btn" ng2FileDrop [uploader]="uploader"
                    (fileOver)="fileOverBase($event)" (onFileDrop)="onFileDrop($event)"
                    [ngClass]="{'file-drop-hover': hasBaseDropZoneOver}" (click)="fileInput.click()">
                    <b *ngIf="proccessingFiles.length === 0">
                        {{ 'printing-table.upload-file-first' | translate }}
                    </b>
                    <b *ngIf="proccessingFiles.length > 0">
                        {{ 'printing-table.upload-file-next' | translate }}
                    </b>

                    <input type="file" ng2FileSelect [uploader]="uploader" #fileInput hidden multiple />
                </button>
                <!-- next image [btn main action btn] -->
                <button *ngIf="!isAllFilesHavePaper && files.length !== 0 &&
                  files.length !== proccessingFiles.length && !isLoadingPreview && !isLoading"
                    [disabled]="isLoading || !currentFile?.printSettings?.paperType" color="primary" type="button"
                    mat-raised-button class="text-white rounded-pill w-100 zx-small-btn" [@mainBtnAnimation]="mainBtn"
                    [class.opacity-50]="isDarkMode" (click)="nextImageToSetPaper()">
                    <b>
                        {{ 'printing-table.next-file' | translate }}
                    </b>
                </button>
                <!-- send to print [btn main action btn] -->
                <button *ngIf="(isAllFilesHavePaper && files.length !== 0 &&
                files.length !== proccessingFiles.length && !isLoadingPreview) && !isLoading"
                    [@mainBtnAnimation]=" mainBtn" [disabled]="isLoading" color="primary" type="button"
                    mat-raised-button class="text-white rounded-pill w-100 zx-small-btn">
                    <b *ngIf="!user || ((!user.discount || user?.discount === 0) && user?.points === 0)">
                        {{ 'printing-table.to-order-summery' | translate }}
                    </b>
                    <span *ngIf="!(!user || ((!user.discount || user?.discount === 0) && user?.points === 0))">
                        <b class="d-none d-sm-inline">
                            {{ 'printing-table.to-order-summery' | translate }}
                        </b>
                        <b class="d-sm-none">
                            {{ 'choose-system.continue' | translate }}
                        </b>
                    </span>
                    <!-- prising [MOBILE] -->
                    <span class="d-md-none"
                        *ngIf="totalOrderPrice && totalOrderPriceBeforeDiscount && totalOrderPrice !== 0 && totalOrderPriceBeforeDiscount !== 0">
                        <span class="zx-100-opacity">__</span>
                        <span>(</span>
                        <!-- before discount price -->
                        <span class="opacity-75 zx-text-tiny" *ngIf="(!((totalOrderPrice - totalOrderPriceBeforeDiscount < 0.05) && (totalOrderPrice - totalOrderPriceBeforeDiscount > -0.05))
                                                    && totalOrderPrice > 0 && totalOrderPriceBeforeDiscount > 0) ||
                                                    (user?.discount && user?.discount > 0)">
                            <span class="strikethrough">
                                {{roundDownTowDecimal(totalOrderPriceBeforeDiscount)}}
                            </span>
                            <span class="zx-100-opacity">-</span>
                        </span>
                        <!-- real price (after discount) -->
                        <span *ngIf="totalOrderPrice > 0 && totalOrderPriceBeforeDiscount > 0">
                            <!-- no user discount -->
                            <span *ngIf="!user || !user.discount || user?.discount === 0">
                                {{
                                totalOrderPrice > user?.points ?
                                roundDownTowDecimal( totalOrderPrice - user?.points) :
                                0
                                }}
                            </span>
                            <!-- there is user discount -->
                            <span *ngIf="user?.discount && user?.discount > 0">
                                {{
                                totalOrderPrice > user?.points ?
                                roundDownTowDecimal((totalOrderPrice * (1 - (user?.discount / 100))) - user.points) :
                                0
                                }}
                            </span>
                        </span>
                        <span class="zx-text-tiny-tiny">
                            {{ 'printing-table.nis' | translate }}
                        </span>
                        <!-- if have points -->
                        <span *ngIf="totalOrderPrice > 0 && totalOrderPriceBeforeDiscount > 0 && (user?.points >= 0.1)">
                            <span class="zx-text-tiny">+</span>
                            <!-- no user discount -->
                            <span *ngIf="!user?.discount || user?.discount === 0">
                                {{
                                totalOrderPrice > user.points ? roundDownTowDecimal(user.points) :
                                roundDownTowDecimal(totalOrderPrice)
                                }}
                            </span>
                            <!-- there is user discount -->
                            <span *ngIf="user?.discount && user?.discount > 0">
                                {{
                                totalOrderPrice * (1 - (user.discount / 100)) > user.points ?
                                roundDownTowDecimal(user.points) :
                                roundDownTowDecimal(totalOrderPrice * (1 - (user.discount / 100)))
                                }}
                            </span>
                            <span class="zx-text-tiny-tiny">
                                {{ 'printing-table.points-short' | translate }}
                            </span>
                        </span>
                        <span>)</span>
                    </span>
                    <!-- // prising [MOBILE] -->
                </button>
            </div>
        </div>

        <!-- IMAGE PREVIEW ********************************************************************* -->
        <!-- ======================================== 2D ======================================== -->
        <article *ngIf="!is3D" [class.d-md-flex]="!is3D" [class.d-none]="is3D || !isPreviewShowen"
            [class.zx-preview-overlay]="!is3D && isPreviewShowen" [class.zx-preview-overlay-small]="isSmallPreview"
            [class.zx-preview-overlay-small-not-rtl]="isSmallPreview && !isRTL"
            class="flex-grow-1 h-100 zx-p-preview-container overflow-hidden position-relative"
            [class.bg-white]="!isDarkMode">
            <div id="preview-container" class="d-flex w-100 h-100 justify-content-center align-items-center"
                [class.zx-100-opacity]="isLoadingPreview || !currentImage || !currentProductType">
                <div id="preview-paper"
                    class="bg-white shadow-85-strong d-flex flex-column justify-content-center position-relative"
                    [class.align-items-center]="centerValue || printingService === 'express'"
                    [class.align-items-end]="!centerValue && printingService !== 'express'"
                    [class.zx-canvas-dark]="isDarkMode">
                    <div id="preview-image-container" class="position-absolute">
                        <div *ngIf="currentImage && currentImage.thumbnailPath && isCurrentrotated"
                            class="preview-image-inner"
                            [class.preview-image-inner-centered]="centerValue || printingService === 'express'"
                            [class.preview-image-inner-not-centered]="!centerValue && isRTL && printingService === 'plotter'"
                            [class.preview-image-inner-not-centered-not-rtl]="!centerValue && !isRTL && printingService === 'plotter'">
                            <!-- [plotter] - previev image -->
                            <img *ngIf="printingService === 'plotter' && currentImage && currentImage.thumbnailPath"
                                class="zx-preview-img zx-preview-img-rotated" [class.zx-b-and-w-img]="bwValue"
                                [class.zx-preview-img-rotated-not-rtl]="!isRTL && !centerValue"
                                [src]="serverAddress+'/uploads/' + getUserName() + '/' + currentImage.thumbnailPath.split('/').pop()"
                                alt="Current File Image">
                            <!-- [express] - previev image -->
                            <img *ngIf="printingService === 'express' && currentImage && currentImage.thumbnailPath"
                                class="zx-preview-img zx-preview-img-rotated" [class.zx-b-and-w-img]="bwValue"
                                [class.zx-preview-img-rotated-not-rtl]="!isRTL && !centerValue"
                                [src]="serverAddress+'/uploads/' + getUserName() + '/' + currentImage.thumbnailPath.split('/').pop()"
                                alt="Current File Image">
                        </div>
                        <!-- [plotter] - previev image -->
                        <img *ngIf="printingService === 'plotter' && currentImage && currentImage.thumbnailPath && !isCurrentrotated"
                            class="zx-preview-img" [class.zx-b-and-w-img]="bwValue"
                            [src]="serverAddress+'/uploads/' + getUserName() + '/' + currentImage.thumbnailPath.split('/').pop()"
                            alt="Current File Image">
                        <!-- [express] - previev image -->
                        <img *ngIf="printingService === 'express' && currentImage && currentImage.thumbnailPath && !isCurrentrotated"
                            class="zx-preview-img" [class.zx-b-and-w-img]="bwValue"
                            [src]="serverAddress+'/uploads/' + getUserName() + '/' + currentImage.thumbnailPath.split('/').pop()"
                            alt="Current File Image">
                    </div>

                    <!-- FIXXX -->
                    <article [class.zx-100-opacity]="isLoadingPreview || !currentImage || !currentProductType"
                        class="dimm-container-up">
                        <!-- upper Dim 1 -->
                        <div [class.zx-100-opacity]="roundDownTowDecimal((currentPaperWidth - currentImageWidth) / 2) < 0.3 && printingService === 'express'"
                            id="upperDim1" class="h-100 d-flex flex-column">
                            <div class="w-100 d-flex flex-column align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-up" [class.dimm-number-up-not-rtl]="!isRTL">
                                        <span *ngIf="centerValue || printingService === 'express'" class="zx-text-tiny">
                                            {{ roundDownTowDecimal((currentPaperWidth - currentImageWidth) / 2) }}
                                        </span>
                                        <span *ngIf="!centerValue && printingService === 'plotter'"
                                            class="zx-text-tiny">
                                            {{ roundDownTowDecimal(currentPaperWidth - currentImageWidth) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-up-inner">
                                <div class="dimm-up-lines">
                                    <div class="dimm-up-line"></div>
                                </div>
                            </div>
                        </div>
                        <!-- upper Dim 2 -->
                        <div id="upperDim2" class="h-100 d-flex flex-column">
                            <div class="w-100 d-flex flex-column align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-up" [class.dimm-number-up-not-rtl]="!isRTL">
                                        <span class="zx-text-tiny">
                                            {{ roundDownTowDecimal(currentImageWidth) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-up-inner">
                                <div class="dimm-up-lines">
                                    <div class="dimm-up-line"></div>
                                </div>
                            </div>
                        </div>
                        <!-- upper Dim 3 -->
                        <div [class.zx-100-opacity]="roundDownTowDecimal((currentPaperWidth - currentImageWidth) / 2) < 0.3 ||
                                                 (printingService === 'plotter' && !centerValue)" id="upperDim3"
                            class="h-100 d-flex flex-column">
                            <div class="w-100 d-flex flex-column align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-up" [class.dimm-number-up-not-rtl]="!isRTL">
                                        <span class="zx-text-tiny">
                                            {{ roundDownTowDecimal((currentPaperWidth - currentImageWidth) / 2) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-up-inner">
                                <div class="dimm-up-lines">
                                    <div class="dimm-up-line"></div>
                                </div>
                            </div>
                        </div>
                    </article>
                    <!-- plotter -->
                    <article class="dimm-container-side" *ngIf="printingService === 'plotter'"
                        [class.zx-100-opacity]="isLoadingPreview || !currentImage || !currentProductType"
                        [class.dimm-container-side-not-rtl]="!isRTL">
                        <div class="h-100 d-flex align-items-center">
                            <div class="position-relative">
                                <div class="dimm-number-side" [class.dimm-number-side-not-rtl]="!isRTL"
                                    [class.dimm-number-side-not-rtl-height]="!isRTL && currentImageHeight > currentImageWidth">
                                    <span class="zx-text-tiny">{{ roundDownTowDecimal(currentPaperHeight) }}</span>
                                    <span class="zx-text-tiny-tiny">
                                        {{ "printing-table.dimensions-cm" | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="dimm-container-side-inner">
                            <div class="dimm-side-lines">
                                <div class="dimm-side-line"></div>
                            </div>
                        </div>
                    </article>
                    <!-- express -->
                    <article class="dimm-container-side-express" *ngIf="printingService === 'express'"
                        [class.zx-100-opacity]="isLoadingPreview || !currentImage || !currentProductType"
                        [class.dimm-container-side-not-rtl-express]="!isRTL">
                        <!-- sider Dim 1 -->
                        <div id="siderDim1" class="d-flex flex-row-reverse"
                            [class.zx-100-opacity]="roundDownTowDecimal((currentPaperHeight - currentImageHeight) / 2) < 0.3">
                            <div class="h-100 d-flex align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-side" [class.dimm-number-side-not-rtl]="!isRTL"
                                        [class.dimm-number-side-not-rtl-height]="!isRTL && currentImageHeight > currentImageWidth">
                                        <span class="zx-text-tiny">
                                            {{ roundDownTowDecimal((currentPaperHeight - currentImageHeight) / 2) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-side-inner">
                                <div class="dimm-side-lines">
                                    <div class="dimm-side-line"></div>
                                </div>
                            </div>
                        </div>
                        <!-- sider Dim 2 -->
                        <div id="siderDim2" class="d-flex flex-row-reverse">
                            <div class="h-100 d-flex align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-side" [class.dimm-number-side-not-rtl]="!isRTL"
                                        [class.dimm-number-side-not-rtl-height]="!isRTL && currentImageHeight > currentImageWidth">
                                        <span class="zx-text-tiny">{{ roundDownTowDecimal(currentImageHeight) }}</span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-side-inner">
                                <div class="dimm-side-lines">
                                    <div class="dimm-side-line"></div>
                                </div>
                            </div>
                        </div>
                        <!-- sider Dim 3 -->
                        <div id="siderDim3" class="d-flex flex-row-reverse"
                            [class.zx-100-opacity]="roundDownTowDecimal((currentPaperHeight - currentImageHeight) / 2) < 0.3">
                            <div class="h-100 d-flex align-items-center">
                                <div class="position-relative">
                                    <div class="dimm-number-side" [class.dimm-number-side-not-rtl]="!isRTL"
                                        [class.dimm-number-side-not-rtl-height]="!isRTL && currentImageHeight > currentImageWidth">
                                        <span class="zx-text-tiny">
                                            {{ roundDownTowDecimal((currentPaperHeight - currentImageHeight) / 2) }}
                                        </span>
                                        <span class="zx-text-tiny-tiny">
                                            {{ "printing-table.dimensions-cm" | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="dimm-container-side-inner">
                                <div class="dimm-side-lines">
                                    <div class="dimm-side-line"></div>
                                </div>
                            </div>
                        </div>

                    </article>

                </div>
            </div>
            <div class="h-100" style="width: 50px;"></div>
            <button *ngIf="isPreviewShowen" mat-button class="preview-button" [class.preview-button-not-rtl]="!isRTL"
                [class.preview-button-small]="isSmallPreview" (click)="hidePreview()">
                <div class="d-flex align-items-center gap-2" [class.justify-content-center]="isSmallPreview">
                    <span *ngIf="!isSmallPreview" class="zx-text-tiny m-0">
                        {{'order-summary-edit' | translate}}
                    </span>
                    <span *ngIf="isSmallPreview" class="zx-text-tiny m-0">
                        {{'close-branch.btn' | translate}}
                    </span>
                    <mat-icon *ngIf="!isSmallPreview" class="mt-1 mx-0 mb-0">edit</mat-icon>
                    <mat-icon *ngIf="isSmallPreview" class="mt-1 mx-0 mb-0">cancel</mat-icon>
                </div>
            </button>
            <button *ngIf="isPreviewShowen && isSmallPreview" mat-button
                class="preview-button preview-button-small preview-button-small-up"
                [class.preview-button-not-rtl]="!isRTL" (click)="showPreview()">
                <div class="d-flex align-items-center gap-2" [class.justify-content-center]="isSmallPreview">
                    <span class="zx-text-tiny m-0">
                        {{'printing-table.full-screen' | translate}}
                    </span>
                    <mat-icon class="mt-1 mx-0 mb-0">fullscreen</mat-icon>
                </div>
            </button>
        </article>
        <!-- // ======================================== 2D ======================================== -->

        <!-- ======================================== 3D ======================================== -->
        <article [class.d-md-flex]="is3D" [class.d-none]="!is3D || !isPreviewShowen"
            [class.zx-preview-overlay]="is3D && isPreviewShowen" [class.zx-preview-overlay-small]="isSmallPreview"
            [class.zx-preview-overlay-small-not-rtl]="isSmallPreview && !isRTL"
            class="flex-grow-1 h-100 zx-p-preview-container overflow-hidden position-relative canvas-container">
            <div class="cube-container" #cubeContainer></div>
            <button *ngIf="isPreviewShowen" mat-button class="preview-button" [class.preview-button-not-rtl]="!isRTL"
                [class.preview-button-small]="isSmallPreview" (click)="hidePreview()">
                <div class="d-flex align-items-center gap-2" [class.justify-content-center]="isSmallPreview">
                    <span *ngIf="!isSmallPreview" class="zx-text-tiny m-0">
                        {{'order-summary-edit' | translate}}
                    </span>
                    <span *ngIf="isSmallPreview" class="zx-text-tiny m-0">
                        {{'close-branch.btn' | translate}}
                    </span>
                    <mat-icon *ngIf="!isSmallPreview" class="mt-1 mx-0 mb-0">edit</mat-icon>
                    <mat-icon *ngIf="isSmallPreview" class="mt-1 mx-0 mb-0">cancel</mat-icon>
                </div>
            </button>
            <button *ngIf="isPreviewShowen && isSmallPreview" mat-button
                class="preview-button preview-button-small preview-button-small-up"
                [class.preview-button-not-rtl]="!isRTL" (click)="showPreview()">
                <div class="d-flex align-items-center gap-2" [class.justify-content-center]="isSmallPreview">
                    <span class="zx-text-tiny m-0">
                        {{'printing-table.full-screen' | translate}}
                    </span>
                    <mat-icon class="mt-1 mx-0 mb-0">fullscreen</mat-icon>
                </div>
            </button>
        </article>
        <!--// ======================================== 3D ======================================== -->

    </div>
</div>